/**
 * [AUTO GENERATED] All changes will be lost on npm run.
 * @deprecated Use OrderState instead.
 */
export default {
    data() {
        return {
            OrderStates: {
				Pending: 'pending',
				Confirmed: 'confirmed',
				Rejected: 'rejected',
				Cancelled: 'cancelled',
				Refunded: 'refunded',
				RefundPending: 'refund_pending',
				Send: 'send',
				ReadyForPickup: 'pickup',
				PickedUp: 'collected',
				WaitForIntegration: 'wait_for_integration',
				WaitForPayment: 'wait_for_payment',
				Delivered: 'delivered',
				RefusedPickup: 'not_collected'
            },
            BillableOrderStates: [
				'send',
				'collected',
				'delivered'
            ]
        };
    }
};